import React from 'react';
import { SessionCountdown } from './SessionCountdown';
export function TopBar() {
  return <div className="sticky top-0 z-50 w-full bg-clay text-ivory py-2.5 px-4 text-center text-sm font-medium shadow-md" data-id="element-341">
      <p className="flex items-center justify-center gap-2 flex-wrap" data-id="element-342">
        <span aria-hidden="true" data-id="element-343">🔥</span>
        <span className="font-semibold tracking-wide" data-id="element-344">
          OFERTA ESPECIAL · 75% OFF
        </span>
        <span className="hidden sm:inline opacity-70" data-id="element-345">—</span>
        <span data-id="element-346">
          Termina en: <SessionCountdown className="font-bold" variant="short" data-id="element-347" />
        </span>
      </p>
    </div>;
}